import { useGetUserProgram as useGeneratedGetUserProgram } from "@/api/generated";
import type {
  CareTeamResponse,
  ProgramID,
  ProgramStatus,
} from "@/api/generated/models";

export const useGetUserProgram = (program: ProgramID | undefined) =>
  useGeneratedGetUserProgram(program as ProgramID, {
    query: {
      enabled: program !== undefined,
      select: (
        userProgram,
      ): { status: ProgramStatus; careTeam: CareTeamResponse | undefined } => {
        const { pcp, referral } = userProgram.details;
        return {
          status: userProgram.status,
          careTeam:
            pcp && referral
              ? ({ pcp, referral } as CareTeamResponse)
              : undefined,
        };
      },
    },
  });
